import { useCallback } from 'react'
import * as React from 'react'

import LoyaltySocietePointsFilterGroup from 'loyalty/components/LoyaltySocietePointsFilterGroup'
import getIsExperienceLoyaltyBurnEnabled from 'loyalty/selectors/getIsExperienceLoyaltyBurnEnabled'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { getUrlOfferListFilters } from 'selectors/routerSelectors'
import { replace } from 'lib/routing/appRouting'
import { deleteSearchParams, setSearchParamValue } from 'lib/url/searchUrlUtils'

function TourSearchSocieteFilters() {
  const isBurnEnabled = useAppSelector(getIsExperienceLoyaltyBurnEnabled)
  const dispatch = useAppDispatch()
  const filters = useAppSelector(getUrlOfferListFilters)
  const windowSearch = useAppSelector(state => state.router.location.search)
  const viewPriceInPoints = !!filters.viewPriceInPoints

  const handleViewPriceInPointsChange = useCallback((nextViewPriceInPoints: boolean) => {
    const search = nextViewPriceInPoints
      ? setSearchParamValue(windowSearch, 'viewPriceInPoints', 'true')
      : deleteSearchParams(windowSearch, 'viewPriceInPoints')
    dispatch(replace({ search }))
  }, [windowSearch, dispatch])

  // The Société controls (burn toggle/slider, "View Price in Points") live
  // inside the tour filter `<form onChange>`, but they are not part of the
  // filter submit payload. Stop their change events from bubbling so they
  // don't trigger the debounced filter re-apply, which would rewrite the URL,
  // refetch facets/offers and clear the burn batch cache (causing the price to
  // flash back to cash while the toggle stays on).
  const stopChangePropagation = useCallback((e: React.FormEvent<HTMLDivElement>) => {
    e.stopPropagation()
  }, [])

  if (!isBurnEnabled) {
    return null
  }

  return (
    <div onChange={stopChangePropagation}>
      <LoyaltySocietePointsFilterGroup
        skipBurnExperiment
        viewPriceInPoints={viewPriceInPoints}
        onViewPriceInPointsChange={handleViewPriceInPointsChange}
      />
    </div>
  )
}

export default TourSearchSocieteFilters
